<template>
    <div
        v-if="!step.hidden"
        :id="step.name"
        class="mobile-menu">
        <NuxtLink
            class="nav-item"
            :class="{'disabled': step.disabled}"
            :to="{
                path: localePath({name: 'registration-id-' + step.name}),
                query: $route.query
            }">
            <div
                class="card"
                :class="{'card-invisible': isActive}">
                <div
                    class="title"
                    :class="isActive ? 'h1' : 'h2 mb-0'">
                    <component
                        :is="'MenuItem' + step.name.charAt(0).toUpperCase() + step.name.slice(1)"
                        class="menu-items"
                        mobile-menu />
                </div>
            </div>
        </NuxtLink>
    </div>
</template>

<script>
import regStart from "@/pages/registration/[id]/regStart";
import participants from "@/pages/registration/[id]/participants";
import registrationDetails from "@/pages/registration/[id]/registrationDetails";
import participantsDetails from "@/pages/registration/[id]/participantsDetails";
import payment from "@/pages/registration/[id]/payment";
import regSummary from "@/pages/registration/[id]/regSummary";
import MenuItemParticipants from "@/components/layouts/eventRegistration/MenuItemParticipants";
import MenuItemParticipantsDetails from "@/components/layouts/eventRegistration/MenuItemParticipantsDetails";
import MenuItemPayment from "@/components/layouts/eventRegistration/MenuItemPayment";
import MenuItemRegistrationDetails from "@/components/layouts/eventRegistration/MenuItemRegistrationDetails";
import MenuItemRegSummary from "@/components/layouts/eventRegistration/MenuItemRegSummary";
import registrationStepsAndValidationMixin from "@/mixins/registration/registrationStepsAndValidationMixin";
import MenuItemRegStart from "@/components/layouts/eventRegistration/MenuItemRegStart";

export default {
    name: "MobileMenu",
    components: {
        MenuItemRegStart,
        MenuItemRegSummary,
        MenuItemRegistrationDetails,
        MenuItemPayment,
        MenuItemParticipantsDetails,
        MenuItemParticipants,
        regStart,
        participants,
        registrationDetails,
        participantsDetails,
        payment,
        regSummary
    },
    mixins: [registrationStepsAndValidationMixin],
    props: {
        step: {
            required: true,
            type: Object
        },
    },
    data() {
        return {
            stepName: null
        }
    },
    computed: {
        isActive() {
            return this.step.name === this.activeStep.name
        }
    }
}
</script>

<style lang="scss" scoped>
    .card, .title{
        transition: all $registration-transition-duration $registration-timing-function;
    }

    .card{
        padding: map-get($spacers, 3);
        margin: map-get($spacers, 2) map-get($spacers, 0);
    }


    .card-invisible {
        background-color: rgba(255, 255, 255, 0);
        box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0);
        padding: map-get($spacers, 3) 0 0 0;

        @include media-breakpoint-up(md) {
            margin-top: map-get($spacers, -4);
        }
    }

    .nav-item.disabled {
        pointer-events: none;
        .h1, .h2{
            color: $nav-item-disabled-color;
        }
    }

    .menu-items > :nth-child(2){
        margin-left: map-get($spacers, 2);
    }
</style>
